import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AuthService } from "../../services/auth/auth.service";
import { LocationStrategy } from "@angular/common";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { AppConfig } from "../../../app.config";
let AuthGuard = class AuthGuard {
    authService;
    url;
    appConfig;
    isAuthenticated;
    iAuthenticatedSubscription;
    constructor(authService, url, appConfig) {
        this.authService = authService;
        this.url = url;
        this.appConfig = appConfig;
        this.iAuthenticatedSubscription = authService.$isAuthenticated.subscribe(next => this.isAuthenticated = next);
    }
    canActivate(route, state) {
        return this.handleActivation();
    }
    canActivateChild(childRoute, state) {
        return this.handleActivation();
    }
    handleActivation() {
        if (this.url.path().includes("/unsecure")) {
            return true;
        }
        else if (this.isAuthenticated) {
            return true;
        }
        else {
            this.appConfig.load().then(() => {
                this.authService.authenticate().then(r => {
                });
            });
            return false;
        }
    }
    static ctorParameters = () => [
        { type: AuthService },
        { type: LocationStrategy },
        { type: AppConfig }
    ];
};
AuthGuard = __decorate([
    Injectable({
        providedIn: "root"
    }),
    AutoUnsub()
], AuthGuard);
export { AuthGuard };
